import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnUpgradeArgs, SubscriptionType } from 'src/app/models/subscription';
import { PromoCode, PromoService } from 'src/app/services/promo.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { ToastService } from 'src/app/services/toast.service';
import { LocalizationModule } from "../../../modules/localization/localization.module";
import { UpgradeCardComponent } from "./upgrade-card/upgrade-card.component";
import { IonHeader, IonToolbar, IonTitle } from "@ionic/angular/standalone";
import { ComponentMemory } from 'src/app/models/memory';
import { ViewDidLeave, ViewWillEnter } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-upgrade',
  templateUrl: './upgrade.component.html',
  styleUrls: ['./upgrade.component.scss'],
  standalone: true,
  imports: [IonTitle, IonToolbar, IonHeader, LocalizationModule, UpgradeCardComponent]
})
export class UpgradeComponent implements ComponentMemory, OnInit, ViewWillEnter, ViewDidLeave {

  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  promoService = inject(PromoService);
  subscriptionService = inject(SubscriptionService);
  toastService = inject(ToastService);

  discountAmount = signal(this.promoService.appliedPromo()?.discountAmount ?? 0);
  classicPrice = this.subscriptionService.subscriptionPricing[SubscriptionType.Classic].price;
  premiumPrice = this.subscriptionService.subscriptionPricing[SubscriptionType.Premium].price;
  platinumPrice = this.subscriptionService.subscriptionPricing[SubscriptionType.Platinum].price;;
  SubscriptionType = SubscriptionType;
  creatingSubscription = signal(false);

  subscription = new Subscription();
  initialized = signal(false);

  ngOnInit(): void {
    this.init();
  }

  ionViewWillEnter(): void {
    this.init();
  }

  ionViewDidLeave(): void {
    this.dispose();
  }

  init(): void {
    if (this.initialized()) return;
    if (this.subscription.closed) {
      this.subscription = new Subscription();
    }
    const promoCodeSubscription = this.promoService.promoCode$.subscribe(promo => this.discountAmount.set((promo as PromoCode).discountAmount));
    this.subscription.add(promoCodeSubscription);
    this.initialized.set(true);
  }

  dispose(): void {
    this.subscription.unsubscribe();
    this.initialized.set(false);
  }

  async onUpgrade(upgradeArgs: OnUpgradeArgs) {
    if (this.creatingSubscription()) return; // prevent rage clicking
    this.creatingSubscription.set(true);
    try {
      if (!upgradeArgs.amount) {
        await this.subscriptionService.createSubscriptionWithoutPayment({ subscriptionType: upgradeArgs.subscriptionType, isActive: true });
        this.router.navigateByUrl('/dashboard/pages/0/edit?activeIndex=0');
      } else {
        this.router.navigateByUrl(`/user/pay?subscriptionType=${upgradeArgs.subscriptionType}`);
      }
    } catch (e) {
      const error = e as HttpErrorResponse;
      this.toastService.error(error.error.message);
    } finally {
      this.creatingSubscription.set(false);
    }
  }
}
